module.exports = __webpack_public_path__ + "fdcff82ee5644483a8d73b36f68b189a.png";